import { styled } from '@gogame/components';

import { getStatusIndicatorColor } from './getStatusIndicatorColor';

export const StatusIndicator = styled('span')`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 8px;
  display: inline-block;
  flex-shrink: 0;
  background-color: ${({ theme, status }) =>
    theme.palette[getStatusIndicatorColor(status)].main};
`;
